import { Action } from '@ngrx/store';
import { Consignee  } from '@app/models/consignee';

export enum ConsigneeActionTypes {
       Load    = '[API] Load consignee',
       LoadSuccess = '[API] Load consignee success',
       LoadFail = '[API] Load consignee fail',

       Create = '[API] Create consignee',
       CreateSuccess = '[API] Create consignee  success',
       CreateFail = '[API] Create consignee fail',	

       Update = '[API] Update consigneer',
       UpdateSuccess = '[API] Update consignee success',
       UpdateFail = '[API] Update consignee  fail',
}

export class Load implements Action {
       readonly type = ConsigneeActionTypes.Load;
	 constructor(public DestinationCenterId?: number) {}
}

export class LoadSuccess implements Action {
       readonly type = ConsigneeActionTypes.LoadSuccess;
	 constructor(public consignee: any[]) {}
}

export class LoadFail implements Action {
       readonly type = ConsigneeActionTypes.LoadFail;
       constructor(public error: any) {}
}

export class Create implements Action {
       readonly type = ConsigneeActionTypes.Create;
       constructor(public data: any) {}
}

export class CreateSuccess implements Action {
       readonly type = ConsigneeActionTypes.CreateSuccess;
       constructor(public data: any) {}
}

export class CreateFail implements Action {
       readonly type = ConsigneeActionTypes.CreateFail;
       constructor(public error: any) {}
}

export class Update implements Action {
       readonly type = ConsigneeActionTypes.Update;
       constructor(public id: number, public consignee: any) {}
}

export class UpdateSuccess implements Action {
       readonly type = ConsigneeActionTypes.UpdateSuccess;
       constructor(public data: any) {}
}

export class UpdateFail implements Action {
       readonly type = ConsigneeActionTypes.UpdateFail;
       constructor(public error: any) {}
}

export type ConsigneeActionsUnion =
| Load
| LoadSuccess
| LoadFail
| Create
| CreateSuccess
| CreateFail
| Update
| UpdateSuccess
| UpdateFail;
